import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromActions from './corporate-dashboard.actions';
import { CorporateAppointmentDashboardService } from '../../shared/services/corporate-appointment-dashboard.service';

@Injectable()
export class CorporateDashboardEffects {
  loadAppointments: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadCorporateDashboardAppointments>(
      fromActions.CorporateDashboardActionTypes.LOAD_APPOINTMENTS
    ),
    switchMap((action: fromActions.LoadCorporateDashboardAppointments) =>
      this.dashboardService.getAppointmentRecords(action.payload.query).pipe(
        map(appointments => new fromActions.LoadCorporateDashboardAppointmentsSuccess({ appointments })),
        catchError(err => of(new fromActions.LoadCorporateDashboardAppointmentsFailure({ error: err?.message || err })))
      )
    )
  ));

  loadDashboardCounts$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadDashboardCounts>(
      fromActions.CorporateDashboardActionTypes.LOAD_DASHBOARD_COUNTS
    ),
    switchMap(() =>
      this.dashboardService.getDashboardCounts().pipe(
        map(response => new fromActions.LoadDashboardCountsSuccess({ counts: response.data })),
        catchError(err => of(new fromActions.LoadDashboardCountsFailure({ error: err?.message || err })))
      )
    )
  ));

  constructor(
    private readonly actions$: Actions,
    private readonly dashboardService: CorporateAppointmentDashboardService
  ) {
  }
}
